import React from "react";
import { WarningCircle } from "@phosphor-icons/react";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  // Fungsi ini otomatis terpanggil jika ada anak komponen yang error
  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  // Fungsi ini berguna untuk mencatat error di Console atau ke Server Logging
  componentDidCatch(error, errorInfo) {
    console.error("🚨 [ERROR BOUNDARY] Menangkap masalah:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // Tampilan darurat saat terjadi crash pada komponen (Fallback UI)
      return (
        <div className="flex w-full min-h-[250px] flex-col items-center justify-center rounded-lg border border-red-200 bg-red-50 p-6 text-center shadow-sm">
          <WarningCircle className="mb-3 h-12 w-12 text-red-500 animate-pulse" />
          <h2 className="mb-1 text-lg font-bold text-red-700">Terjadi Gangguan Tampilan</h2>
          <p className="mb-4 max-w-md text-sm text-red-600/80">
            Sebagian komponen di halaman ini gagal dimuat. Jangan khawatir, sisa aplikasi Anda masih berjalan normal.
          </p>
          <button
            onClick={() => window.location.reload()}
            className="rounded-md bg-red-600 px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2"
          >
            Muat Ulang Halaman
          </button>
        </div>
      );
    }

    // Jika tidak ada error, tampilkan komponen seperti biasa
    return this.props.children;
  }
}

export default ErrorBoundary;